import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-reset-check',
  templateUrl: './icon-reset-check.component.html',
  styles: []
})
export class IconResetCheckComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
